class DFFCloneService {
  static cloneSection = async (api, configuration, label) => {
    api.onSaveCloneSection(label, configuration.id);
  };

  static removeSection = async (api, configuration) => {
    api.onDeleteSectionCloned(configuration.id);
  };
}

export default DFFCloneService